import React from 'react';
import { Button, Result } from 'antd';
import {useNavigate} from 'react-router-dom';
export default  (props) => {
    
    const {fourZerofour} = props
    const navigate  = useNavigate();
    return(
        <Result
          status="404"
          title="404"
          subTitle={fourZerofour ? "Sorry, we couldn't find any data." : "Sorry, the page you visited does not exist."}
          extra={ !fourZerofour && <Button onClick={()=>navigate(-1)} type="primary">Back</Button>}
        />
      );
}

 